import {
  FacebookTargetingSpec,
  exampleFacebookTargetingSpec,
  SavedAudienceStandardTargetingSpec,
} from '../../facebook/audience';
import { exampleUser, User } from '../../user';

export interface SavedAudience {
  id: number;
  businessID: number;
  name: string;
  description?: string;
  type: SavedAudienceType;
  isDefault: boolean;
  isPotentialApproximation: boolean;
  status: SavedAudienceStatus;
  facebookID?: string;
  approximateCountLowerBound: number;
  approximateCountUpperBound: number;
  created_at?: number;
  updated_at: number;
  timeLastUsed?: number;
  targeting: FacebookTargetingSpec;
  numberOfTimesUsed: number;
  deleted: boolean;
  createdWithMM: boolean;
  history?: SavedAudienceHistory[];
  /**
   * Whether the connected ad account still holds this audience. `undefined` means availability was
   * not evaluated for this response — treat it as available, which is how a business whose
   * audiences have never been reconciled behaves.
   */
  availableInAdAccount?: boolean;
}

export enum SavedAudienceType {
  AI = 'AI',
  HumanMade = 'HUMAN_MADE',
  WebsiteTraffic = 'WEBSITE_TRAFFIC',
  EngagedUser = 'ENGAGED_USERS',
  LeadCard = 'LEAD_CARD',
  MMGenerated = 'MM_GENERATED',
  CustomerFile = 'CUSTOMER_FILE',
  FacebookImported = 'FACEBOOK_IMPORTED',
}

export enum SavedAudienceStatus {
  Active = 'ACTIVE',
  Processing = 'PROCESSING',
}

export const exampleSavedAudience: SavedAudience = {
  id: 1,
  businessID: 1,
  isDefault: false,
  name: 'New Customers',
  description: 'Lorem ipsum',
  type: SavedAudienceType.HumanMade,
  status: SavedAudienceStatus.Active,
  facebookID: '123',
  approximateCountLowerBound: 55000,
  approximateCountUpperBound: 66000,
  isPotentialApproximation: false,
  created_at: undefined,
  updated_at: 1603908720,
  timeLastUsed: 1603908740,
  targeting: exampleFacebookTargetingSpec,
  numberOfTimesUsed: 0,
  deleted: false,
  createdWithMM: true,
  history: [
    {
      action: 'CREATE',
      user: exampleUser,
      updatedAt: 1603908720,
    },
    {
      action: 'UPDATE',
      user: exampleUser,
      updatedAt: 1603908920,
    },
  ],
};

export interface SavedAudienceFilter {
  isDefault?: boolean;
}

export interface SavedAudienceDTO {
  name: string;
  description?: string;
  isDefault: boolean;
  targetingSpec: SavedAudienceStandardTargetingSpec;
}

export interface UpdateSavedAudienceDTO {
  name?: string;
  description?: string;
  status?: string;
  isDefault?: boolean;
  deleted?: boolean;
  targetingSpec?: FacebookTargetingSpec;
  isPotentialApproximation?: boolean;
}

export type AudienceAction =
  | 'CREATE'
  | 'UPDATE'
  | 'DELETE'
  | 'SET_DEFAULT'
  | 'UNSET_DEFAULT'
  | 'SET_APPROX'
  | 'UNSET_APPROX';

export interface SavedAudienceHistory {
  action: AudienceAction;
  updatedAt: number;
  user: User;
}

export interface ApproximateAudienceSizes {
  lowerBound: number;
  upperBound: number;
}
